import { IziviaTheme } from './app/domain/theme/iziviaTheme';
import { Language } from './app/domain/utils/i18n/language';

export const theme: IziviaTheme = {
    thirdPartyId: 'F-CB',
    title: '',
    defaultLanguage: Language.EN_GB,
    languagesToDisplay: [Language.FR, Language.EN_GB, Language.NL_NL]
};
